import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { Link, useNavigate, useParams } from 'react-router-dom';
import LoginShell, { feldAngaben, LoginFeldFehler, pruefeFelder, type FeldFehlerListe } from '../components/LoginShell';
import apiClient from '../services/apiClient';
import { API_ENDPOINTS } from '../config/api';
import { PASSWORT_REGEL } from '../config/passwort';

function ResetPassword() {
  const { token: pathToken } = useParams<{ token: string }>();
  const [token] = useState(() => pathToken || window.location.hash.slice(1));
  const navigate = useNavigate();
  const [password, setPassword] = useState(''); const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false); const [error, setError] = useState('');
  const [feldfehler, setFeldfehler] = useState<FeldFehlerListe>({});
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault(); setError('');
    const fehler = pruefeFelder({
      password: !password ? 'Bitte ein neues Passwort eintragen.' : password.length < 8 ? 'Das Passwort muss mindestens 8 Zeichen lang sein.' : undefined,
      confirmPassword: !confirmPassword ? 'Bitte das neue Passwort wiederholen.' : password !== confirmPassword ? 'Die Passwörter stimmen nicht überein.' : undefined,
    });
    setFeldfehler(fehler);
    if (Object.keys(fehler).length) return;
    setLoading(true);
    try { await apiClient.post(API_ENDPOINTS.RESET_PASSWORD, { token, newPassword: password }); navigate('/login?reset=true'); }
    catch (err: any) { setError(err.response?.data?.error || 'Das Passwort konnte nicht geändert werden.'); }
    finally { setLoading(false); }
  };
  return (
    <LoginShell>
      <div className="login-form-wrap">
        <Link to="/login" className="login-back"><ArrowLeftIcon aria-hidden="true" />Zur Anmeldung</Link>
        <h1 id="auth-title">Neues Passwort</h1>
        {/* DR-13 UI-26: ohne Schlüssel gleich der Hinweis wie auf /e-mail-bestaetigen, kein Formular. */}
        {!token ? <div className="login-notice error" role="alert"><strong>Änderung nicht möglich.</strong><span>Der Link ist unvollständig. Öffnen Sie ihn direkt aus der E-Mail oder fordern Sie einen neuen an.</span></div> : <>
        <p id="password-requirements" className="login-intro">{PASSWORT_REGEL} Mit Ihrem neuen Passwort können Sie sich anschließend bei CLAiRIS anmelden.</p>
        <form onSubmit={handleSubmit} noValidate className="login-form" aria-label="Neues Passwort festlegen" aria-busy={loading} aria-describedby={error ? 'reset-error' : undefined}>
          <div className="login-field">
            <label htmlFor="password">Neues Passwort</label>
            <input {...feldAngaben('password', feldfehler, 'password-requirements')} name="newPassword" type="password" value={password} onChange={(e) => { setPassword(e.target.value); setFeldfehler(f => ({ ...f, password: '' })); }} required minLength={8} autoComplete="new-password" />
            <LoginFeldFehler id="password" fehler={feldfehler} />
          </div>
          <div className="login-field">
            <label htmlFor="confirmPassword">Passwort bestätigen</label>
            <input {...feldAngaben('confirmPassword', feldfehler)} name="confirmPassword" type="password" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); setFeldfehler(f => ({ ...f, confirmPassword: '' })); }} required autoComplete="new-password" />
            <LoginFeldFehler id="confirmPassword" fehler={feldfehler} />
          </div>
          {error && <div id="reset-error" className="login-notice error" role="alert"><strong>Änderung nicht möglich.</strong><span>{error}</span></div>}
          <button type="submit" disabled={loading} className="login-submit"><span>{loading ? 'Passwort wird gespeichert …' : 'Passwort speichern'}</span><ArrowRightIcon aria-hidden="true" /></button>
        </form>
        </>}
        <p className="login-inline-help">Link nicht mehr gültig? <Link to="/forgot-password">Neuen Link anfordern</Link></p>
      </div>
    </LoginShell>
  );
}
export default ResetPassword;
